export const ACTIVE_SESSIONS = 'activeSessions';
export const DELETE_ACCOUNT = 'deleteAccount';
export const PAYMENT_METHODS = 'paymentMethods';
export const PERSONAL_INFO = 'personalInfo';
export const PROFILE = 'profile';
export const TRAVEL_COMPANION = 'travelCompanion';

